import styles from './LeftColumnWrapperVersionTwo.css'

class LeftColumnWrapperVersionTwo extends React.Component {
  render () {
    const {openRightColumn} = this.props
    let classSlider = openRightColumn ? 'col-md-5 col-lg-5 visible-md visible-lg visible-sm' : 'col-md-12 col-lg-12'

    return (<div id='mk-col-left' className={`${styles.wrapper} ${classSlider}`}>
      {this.props.children}
    </div>)
  }
}

export default LeftColumnWrapperVersionTwo



// WEBPACK FOOTER //
// ./app/components/wrappers/pages/LeftColumnWrapperVersionTwo/LeftColumnWrapperVersionTwo.js